export default "__VITE_ASSET__CcBq43rB__"